import { createContext, useContext } from "react";

type LayoutContextType = {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (sidebarCollapsed: boolean) => void;
  sidepaneCollapsed: boolean;
  setSidepaneCollapsed: (sidepaneCollapsed: boolean) => void;
};
export const LayoutContext = createContext<LayoutContextType>({
  sidebarCollapsed: false,
  setSidebarCollapsed: () => {},
  sidepaneCollapsed: false,
  setSidepaneCollapsed: () => {},
});

export const useLayout = () => useContext(LayoutContext);
